/**
 * 証拠金レポート（チャート・ツールチップ）で共通の億円フォーマット。
 * 日本語は億単位・小数点1桁、英語は百万単位・整数（呼び出し側が divisor/fractionDigits で指定）。
 */

/** 円額を指定の除数で単位変換する（例: 1e8 で割ると億単位）。 */
export function toOkuValue(rawYen: number, divisor: number): number {
  return rawYen / divisor
}

/** 単位変換済みの値に単位文字列を付与してフォーマットする。 */
export function formatOkuValue(
  okuValue: number,
  unit: string,
  fractionDigits: number,
): string {
  return `${okuValue.toFixed(fractionDigits)}${unit}`
}

/** 円額を億（または百万）単位の文字列に変換する（toOkuValue + formatOkuValue の合成）。 */
export function formatYenOku(
  rawYen: number,
  unit: string,
  divisor: number,
  fractionDigits: number,
): string {
  return formatOkuValue(toOkuValue(rawYen, divisor), unit, fractionDigits)
}
